<template>
    <h1 class="bg-[#F8F9F4] h-[200px] flex items-center justify-center text-2xl font-medium tracking-widest text-center">
        在宅看護指導士<br/>
        資格試験申し込みの確認
    </h1>
</template>

<script>
export default {
    name: "ConfirmHeader"
}
</script>

<style scoped>

</style>
